import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray, AbstractControl, Validators, NgForm, FormControlName, ValidationErrors } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { LoginService } from 'src/app/core/services/login.service';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { ToastService } from 'src/app/core/toast.service';
import { PostnewJob } from '../../services/job-section.service';
import { Router, Routes, RouterModule, ActivatedRoute } from '@angular/router';
import { C } from '@angular/cdk/keycodes';
import { NgxSpinnerService } from 'ngx-spinner';
import { JobDetailsPreviewComponent } from '../job-details-preview/job-details-preview.component';
import { MatDialog } from '@angular/material/dialog';
import { JobInfo } from 'src/app/modules/jobseek/services/jobsinfo.service';
import { ProfileService } from '../../services/profile.service';
import { MatCalendar } from '@angular/material/datepicker';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { TABLE_FIELDS, Tables } from 'src/app/shared/enum/tables.enum';
@Component({
  selector: 'app-job-post',
  templateUrl: './job-post.component.html',
  styleUrls: ['./job-post.component.scss']
})

export class JobPostComponent implements OnInit {
  @ViewChild(MatCalendar) calendar!: MatCalendar<Date>;

  jobPostForm: FormGroup;
  filteredLocations: string[] = [];
  allLocations: string[] = ['Chwaszczyno, Poland', 'Warsaw, Poland', 'Gdansk, Poland', 'Chennai, India'];
  addressName: any;
  latitude: any;
  longitude: any;
  zoom: any;
  pincode: any;
  logoImage: any;
  clinicImg: any;
  bannerImage: any;
  showTypeDt: any = false;
  loginDetails: any;
  jobId: string | null = null;
  jobList: any;
  roles: any[] = [];
  private geoCoder;
  @ViewChild('search')
  public searchElementRef: ElementRef;
  private router: any = ActivatedRoute;
  // @ViewChild("search")
  // public searchElementRef: ElementRef;

  //locum dates
  openCalendarPopup = false;
  EmployeeType: any[] = [];
  showLocumInput = false;
  startDate: Date | null = null;
  endDate: Date | null = null;


  logoPreviewUrl: string = '';
  directorylogoUrl: any;


  @ViewChild("map")
  public mapElementRef: ElementRef;

  public entries = [];

  public place: google.maps.places.PlaceResult;

  public locationFields = ["name", "cityName", "stateCode", "countryName", "countryCode"];
  showTypeDt1: boolean;
  // spinner: any;
  iseditMode: boolean = false; existingStatus: any;
  aboutCompany: any;
  profilelogo: any;
  showCreateButton: boolean;
  jobSeekPermissionLimit: any;
  jobsCount: any;
  showMessage: string;
  jobDescCharCount = 0;

  constructor(private profileService: ProfileService, private routers: Router, r: ActivatedRoute, private loginService: LoginService, private jobService: PostnewJob, private toast: ToastService, private mediaService: MediaService, private _fb: FormBuilder, private dialog: MatDialog, private mapsAPILoader: MapsAPILoader, private ngZone: NgZone, private spinner: NgxSpinnerService, private JobInfo: JobInfo,private commonService:CommonServicesForAllModules) {
    this.router = r;

    this.jobPostForm = this._fb.group({
      erole: [null, [Validators.required]],
      typeofemp: [null, [Validators.required]],
      availability: [[]],
      // estate: [null, [Validators.required]],
      elocation: [null, [Validators.required]],
      jobtitle: [null, [Validators.required, Validators.pattern('^[A-Za-z ]+$')]],
      ecompanyname: [null, [Validators.required]],
      empstate: [null, [Validators.required]],
      epostalcode: [null, [Validators.required]],
      ecountry: [null, [Validators.required]],
      ebanner: [null],
      elogo: [null],
      ejobtype: [null],
      postpalnning: [null, [Validators.required]],
      planningdate: [null, [Validators.required]],
      ehirequick: [null, [Validators.required]],
      enopeople: [null, [Validators.required]],
      erange: [null, [Validators.required]],
      erangemin: [null, [Validators.required]],
      erangemax: [null, [Validators.required]],
      ebilling: [null, [Validators.required]],
      eoffierbenefits: [null],
      ejobdesp: [null, [Validators.required]],
      education: [null],
      experience: [null, [Validators.required]],
      clinicphoto: [null],
      videolink: [null, this.youtubeLoomVimeoUrlValidator],
      website: [null],
      facebook: [null],
      instagram: [null],
      linkedin: [null],
      endDate: [null, [Validators.required]],
      endDateToggle: [null, [Validators.required]],

    });

  }

  ngOnInit(): void {
    this.getLocumDate();
    this.jobId = this.router.snapshot.paramMap.get('id');

    if (this.jobId) {
      this.fetchAndPatchJob();
    }

    this.loginDetails = this.loginService.getLoginData();


    const jobPermission = this.loginDetails?.subscription_permissions?.modules
      ?.find((mod: any) => mod.name === 'job_seek_modules_permission');

    this.showCreateButton = true;
    this.showMessage = "";
    if (jobPermission?.permission) {
      this.jobSeekPermissionLimit = jobPermission.count;
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      const andList: any[] = [
        {
          status: { "_in": ["APPROVE", "PENDING", "INACTIVE"] }
        },
        {
          created_at: {
            _gte: startDate.toISOString(),
            _lt: endDate.toISOString()
          }
        }
      ];
      if (this.loginDetails.type == "SUPPLIER") {
        andList.push({
          dental_supplier_id: { _eq: this.loginDetails.id }
        });
      }
      if (this.loginDetails.type == "PRACTICE") {
        andList.push({
          dental_practice_id: { _eq: this.loginDetails.id }
        });
      }
      this.jobService.getMonthlyJobsCount(andList).subscribe(data => {
        this.jobsCount = data;
        let remainingCount = this.jobSeekPermissionLimit - this.jobsCount;
        if (this.jobSeekPermissionLimit != -1) {
          if (remainingCount <= 0) {
            this.showCreateButton = false;
            this.showMessage = "You have reached maximum limit but you can save them as draft for future. For mor details please contact the admin";
          }
        }
      });

    }

    // Dynamic validator: availability required only for Locum
    this.jobPostForm.get('typeofemp')?.valueChanges.subscribe(value => {
      const availabilityControl = this.jobPostForm.get('availability');
      const isLocum = value?.includes('Locum');

      if (isLocum) {
        availabilityControl?.setValidators([Validators.required]);
      } else {
        availabilityControl?.clearValidators();
        availabilityControl?.setErrors(null);
      }

      availabilityControl?.updateValueAndValidity();
    });

    //Search Address
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          this.addressName = place;
          if (place.formatted_address) {
            this.jobPostForm.controls['elocation'].setValue(place.formatted_address);
          }

          const state = place.address_components.find(single => single.types.includes('administrative_area_level_1'))?.long_name;
          const country = place.address_components.find(single => single.types.includes('country'))?.long_name;
          const postalCode = place.address_components.find(single => single.types.includes('postal_code'))?.long_name;
          const district = place.address_components.find(single => single.types.includes('administrative_area_level_2'))?.long_name;

          this.jobPostForm.controls['empstate'].setValue(state || null);
          this.jobPostForm.controls['ecountry'].setValue(country || null);

          if (postalCode) {
            this.jobPostForm.controls['epostalcode'].setValue(postalCode);
          } else if (district) {
            this.jobPostForm.controls['epostalcode'].setValue(district);
          } else {
            this.jobPostForm.controls['epostalcode'].setValue(null);
          }

          this.latitude = place.geometry?.location?.lat();
          this.longitude = place.geometry?.location?.lng();
          this.zoom = 12;
        });
      });
    });

    // get roles
    this.jobService.getJobsRoleList().subscribe(data => {
      this.roles = data;
    });

    // get Employment Type
    this.jobService.getEmployeeTypeList().subscribe(data => {
      this.EmployeeType = data;
    });

    this.getcompanyDetails();

     const startCtrl = this.jobPostForm.get('planningdate');
    const endCtrl = this.jobPostForm.get('endDate');

    
    if (startCtrl && endCtrl) {
      startCtrl.valueChanges.subscribe(startDate => {

        const endDate = new Date(endCtrl.value);

        if (endDate && startDate && startDate > endDate) {
          endCtrl.setValue(null); // clear end date
        }
      });
    }


  }



  fetchAndPatchJob(): void {
    this.commonService.GetById(Tables.Jobs, this.jobId, TABLE_FIELDS.Jobs).subscribe(data => {
      this.jobList = data;
              
      this.iseditMode = true;
      const jobToEdit = this.jobList;

      this.existingStatus = jobToEdit.status;
      const endDate = {
        value: jobToEdit.endDateToggle
      }
      const startDate = {
        value: jobToEdit.timingtoggle
      }
      this.getendDatePlanningAction(endDate);
      this.getPostPlanningAction(startDate);
      if (jobToEdit) {
        //  Safely set startDate and endDate from availability array
        // if (Array.isArray(jobToEdit.availability_date) && jobToEdit.availability_date.length > 0) {
        //   this.startDate = new Date(jobToEdit.availability_date[0]);
        //   this.endDate = new Date(jobToEdit.availability_date[jobToEdit.availability_date.length - 1]);
        // } else {
        //   this.startDate = null;
        //   this.endDate = null;
        // }

        this.jobPostForm.patchValue({
          jobtitle: jobToEdit.title,
          ejobtype: jobToEdit.j_type,
          erole: jobToEdit.j_role,
          ejobdesp: jobToEdit.description,
          typeofemp: jobToEdit.TypeofEmployment,
          // availability: jobToEdit.availability_date,
          experience: jobToEdit.years_of_experience,
          elocation: jobToEdit.location,
          empstate: jobToEdit.state,
          epostalcode: jobToEdit.city,
          erangemax: jobToEdit.pay_max,
          erangemin: jobToEdit.pay_min,
          ecompanyname: jobToEdit.company_name,
          erange: jobToEdit.pay_range,
          education: jobToEdit.education,
          videolink: jobToEdit.video,
          // endDate: jobToEdit.closed_at ? new Date(jobToEdit.closed_at) : null,
          // endDateToggle: jobToEdit.closed_at ? 'YES' : 'NO',
          website: jobToEdit.website_url,
          ecountry: jobToEdit.country,
          eoffierbenefits: jobToEdit.offered_benefits,
          ehirequick: jobToEdit.hiring_period,
          enopeople: jobToEdit.no_of_people,
          ebilling: jobToEdit.rate_billing,
          facebook: jobToEdit.facebook_url,
          instagram: jobToEdit.instagram_url,
          linkedin: jobToEdit.linkedin_url,
        });

        if (jobToEdit?.status !== 'EXPIRED') {

            if (Array.isArray(jobToEdit.availability_date) && jobToEdit.availability_date.length > 0) {
          this.startDate = new Date(jobToEdit.availability_date[0]);
          this.endDate = new Date(jobToEdit.availability_date[jobToEdit.availability_date.length - 1]);
        } else {
          this.startDate = null;
          this.endDate = null;
        }

          this.jobPostForm.patchValue({
            // planningdate: jobToEdit.start_Date ? new Date(jobToEdit.start_Date)  : null,
            planningdate: jobToEdit.start_Date ? jobToEdit.start_Date : null,
            endDate: jobToEdit.closed_at ? new Date(jobToEdit.closed_at) : null,
             endDateToggle: jobToEdit?.endDateToggle,
            //  postpalnning: jobToEdit.timingtoggle ? 'YES' : 'NO',
             postpalnning: jobToEdit?.timingtoggle,
             availability: jobToEdit.availability_date,

          });
        }


        this.onTypeOfEmpChange();
        // Also patch image variables if needed
        if (jobToEdit.clinic_logo && Array.isArray(jobToEdit.clinic_logo)) {
          this.clinicImages = jobToEdit.clinic_logo.map((item: any) => {
            const url = typeof item === 'string' ? item : item.url;
            const extension = item.extension || url.split('.').pop()?.toLowerCase() || '';
            let fileType = '';
            if (extension.includes('video')) {
              fileType = extension.split('/')[1]; // Split "video/mp4" to get "mp4"
            } else {
              fileType = extension; // For image types, keep the extension as is (e.g., jpeg, png)
            }
            const isVideo = ['mp4', 'mov', 'webm', 'ogg'].includes(fileType);
            return {
              url,
              type: isVideo ? 'video' : 'image',
              extension: fileType
            };
          });
        } else {
          this.clinicImages = [];
        }
        if (jobToEdit.banner_image) {

          this.bannerImage = jobToEdit.banner_image;
        } else {
          this.bannerImage = null;
        }
      }

    });
  }

  clinicImages: any[] = [];



  onSelectThumbnailImage(files: FileList, typ: string) {


    
  // -- VALIDATION FOR CLINIC IMAGES (MAX = 10) ----
  if (typ === 'clinic') {
    const totalSelected = files.length;
    const alreadyUploaded = this.clinicImages.length;

    if (alreadyUploaded + totalSelected > 10) {
      this.toast
        .openSnackBar(`Max 10 Clinic images allowed. Uploaded: ${alreadyUploaded}, Selected: ${totalSelected}.`);
      return;
    }
  }


    Array.from(files).forEach((file: File) => {
      const formData = new FormData();
      formData.append('directory', 'project');
      formData.append('file', file);
      formData.append('Content-Type', 'application/json');
      formData.append('accept', 'application/json');

      this.mediaService.uploadMedia(formData).subscribe(response => {
        const mediaItem = {
          url: response.url,
          type: file.type.startsWith('video') ? 'video' : 'image',
          extension: response.extension || response.mime_type?.split('/')[1] || ''
        };


        if (typ === 'clinic') {
          this.clinicImages.push(mediaItem);
        } else if (typ === 'logo') {
          this.logoImage = mediaItem;
        } else if (typ === 'banner') {
          this.bannerImage = mediaItem;
        }

      });
    });
  }



  // removeImg(index: number): void {
  //   this.clinicImages.splice(index, 1);
  // }
  removeImg(type: 'clinic' | 'logo' | 'banner', index?: number): void {
    if (type === 'clinic' && index !== undefined) {
      this.clinicImages.splice(index, 1);
    } else if (type === 'logo') {
      this.logoImage = null;
    } else if (type === 'banner') {
      this.bannerImage = null;
    }
  }


  getPostPlanningAction(event: any): void {
    if (event.value === 'YES') {
      this.showTypeDt = true;
      this.jobPostForm.get('planningdate')?.setValidators([Validators.required]);
    } else {
      this.showTypeDt = false;
      this.jobPostForm.get('planningdate')?.clearValidators();
      this.jobPostForm.get('planningdate')?.setValue(null);
    }
    this.jobPostForm.get('planningdate')?.updateValueAndValidity();
  }


  getendDatePlanningAction(ev: any): void {
    if (ev.value === 'YES') {
      this.showTypeDt1 = true;
      this.jobPostForm.get('endDate')?.setValidators([Validators.required]);
    } else {
      this.showTypeDt1 = false;
      this.jobPostForm.get('endDate')?.clearValidators();
      this.jobPostForm.get('endDate')?.setValue(null);
    }
    this.jobPostForm.get('endDate')?.updateValueAndValidity();

  }

  // openDialog() {


  //   const dialog = this.dialog.open(JobDetailsPreviewComponent, {
  //     width: '60%',
  //     panelClass: ['custom-modal'],

  //     data: {
  //       ...this.jobPostForm.value, // spread all form controls
  //       // roleName: this.getRoleNameById(this.jobPostForm.get('erole')?.value),
  //       // clinicphoto: this.clinicImg?.url,
  //       clinicImages: this.clinicImages,
  //       elogo: this.loginDetails?.logo,
  //       ebanner: this.bannerImage,
  //       aboutCompanyData: this.aboutCompany,
  //       postPreview: true

  //     }



  //   });

  //   dialog.afterOpened().subscribe(() => {
  //     this.spinner?.hide();
  //   });
  // }

  openDialog() {
    const dialogData = {
      ...this.jobPostForm.value,
      clinicImages: this.clinicImages,
      elogo: this.directorylogoUrl,
      ebanner: this.bannerImage,
      aboutCompanyData: this.aboutCompany,
      postPreview: true
    };


    const dialog = this.dialog.open(JobDetailsPreviewComponent, {
      width: '60%',
      panelClass: ['custom-modal'],
      data: dialogData
    });

    dialog.afterOpened().subscribe(() => {
      this.spinner?.hide();
    });
  }


  filterLocations() {
    const input = this.jobPostForm.get('elocation')?.value?.toLowerCase() || '';
    this.filteredLocations = this.allLocations.filter(location =>
      location.toLowerCase().includes(input)
    );
  }

  selectLocation(selected: string) {
    this.jobPostForm.get('elocation')?.setValue(selected);
  }


  getRoleNameById(id: number): string {
    const role = this.roles.find(r => r.id === id);
    return role ? role.role_name : 'Unknown Role';
  }

  async postJob(postFormClear: any, status: string = 'PENDING') {

    let postjobObj: any = {};
    const formValues = this.jobPostForm.value;
    const isDraft = status === 'DRAFT';

    const isLocum = formValues.typeofemp?.includes('Locum');
    if (!isDraft && isLocum && (!this.startDate || !this.endDate)) {
      this.toast.openSnackBar('Start and End dates are required for Locum jobs.');
      this.jobPostForm.get('availability')?.setErrors({ required: true });
      this.jobPostForm.get('availability')?.markAsTouched();
      return;
    }

    if (!isDraft && this.jobPostForm.invalid) {
      this.toast.openSnackBar('Please Enter Valid Details');
      this.jobPostForm.markAllAsTouched();
      return;
    }


    // If draft, clear validators
    // if (isDraft) {

    //   Object.keys(this.jobPostForm.controls).forEach(field => {
    //     const control = this.jobPostForm.get(field);
    //     control?.clearValidators();
    //     control?.updateValueAndValidity();
    //     control?.setErrors(null);
    //   });
    // }

    // Create job object

    postjobObj = {
      title: formValues.jobtitle || null,
      j_type: formValues.ejobtype || null,
      j_role: formValues.erole || null,
      description: formValues.ejobdesp || null,
      TypeofEmployment: formValues.typeofemp || null,
      availability_date: formValues.availability || null,
      years_of_experience: formValues.experience || null,
      dental_supplier_id: this.loginDetails?.type === 'SUPPLIER' ? this.loginDetails?.id : null,
      dental_practice_id: this.loginDetails?.type === 'PRACTICE' ? this.loginDetails?.id : null,
      location: formValues.elocation || null,
      logo: this.loginDetails?.logo?.url ?? this.directorylogoUrl,
      state: formValues.empstate || null,
      city: formValues.epostalcode || null,
      salary: formValues.erange || null,
      pay_min: formValues.erangemin || null,
      pay_max: formValues.erangemax || null,
      company_name: this.aboutCompany?.company_name || null,
      pay_range: formValues.erange || null,
      education: formValues.education || null,
      video: formValues.videolink || null,
      banner_image: this.bannerImage ?? null,
      clinic_logo: Array.isArray(this.clinicImages) ? [...this.clinicImages] : [],
      clinicphoto: this.clinicImg?.url,
      closed_at: formValues.endDate || null,
      // status: this.iseditMode && this.existingStatus !== 'DRAFT' ? this.existingStatus : status,
      // status: formValues.status,
      // status: this.jobId ? 'PENDING' : status,
      status: status,
      active_status: 'ACTIVE',
      website_url: formValues.website || null,
      country: formValues.ecountry || null,
      endDateToggle: formValues.endDateToggle ?? null,
      offered_benefits: formValues.eoffierbenefits || null,
      hiring_period: formValues.ehirequick || null,
      no_of_people: formValues.enopeople || null,
      rate_billing: formValues.ebilling || null,
      facebook_url: formValues.facebook || null,
      instagram_url: formValues.instagram || null,
      linkedin_url: formValues.linkedin || null,
      start_Date: formValues.planningdate ? this.formatAsYYYYMMDD(formValues.planningdate) :  null,
      timingtoggle: formValues.postpalnning ?? null,
      // auto_expiry_date: formValues.endDateToggle === 'NO' ? this.formatAsYYYYMMDD(new Date()) : null,
      active_status_feed: status === 'DRAFT' ? null : 'PENDING',
      feed_type: 'JOBS',
    };


    try {
      let response: any;
      if (this.jobId && this.jobList.status !== 'EXPIRED') {
        response = await this.commonService.UpdateData(Tables.Jobs ,this.jobId, postjobObj);
      } else {
        response = await this.commonService.InsertData(Tables.Jobs , postjobObj);
      }

      

      if (response) {
        let message = '';
        if (isDraft) {
          message = this.jobId ? 'Job draft updated successfully' : 'Job Saved as Draft Successfully';
        } else {
          message = this.jobId && this.jobList.status !== 'EXPIRED' ? 'Job updated successfully' : 'Job Posted Successfully';
        }
        this.toast.openSnackBar(message);
        this.routers.navigate(['/profile/job-listing']);
      }
    } catch (error) {
      console.error('Error while posting job:', error);
      this.toast.openSnackBar('An error occurred while posting the job.');
    }
  }


  getcompanyDetails() {
    const loginid = this.loginDetails?.id;

    if (!loginid) {
      console.error('No dental_supplier_id or dental_practice_id found.');
      return;
    }


    this.JobInfo.getSelectedComapnyName(loginid).subscribe((data: any) => {
      this.aboutCompany = data?.[0];

      this.jobPostForm.get('ecompanyname')?.setValue(this.aboutCompany?.company_name);

      // this.jobPostForm.get('ecompanyname')?.disable();

      this.directorylogoUrl = this.aboutCompany?.logo?.url;

    });
  }

  // locum date avilability  
  onTypeOfEmpChange() {
    const values: string[] = this.jobPostForm.get('typeofemp')?.value || [];
    this.showLocumInput = values.includes('Locum');

    // If Locum is selected, force the control to only contain Locum
    if (values.includes('Locum') && values.length > 1) {
      this.jobPostForm.get('typeofemp')?.setValue(['Locum']);
    }

    //    (so when user re-selects Locum, it's fresh)
    if (!values.includes('Locum')) {
      this.jobPostForm.get('availability')?.reset(); // clear the form control
      this.startDate = null;
      this.endDate = null;
    }

  }

  /** Disable all other options when Locum is selected */
  isOptionDisabled(option: string): boolean {
    const selected: string[] = this.jobPostForm.get('typeofemp')?.value || [];
    return selected.includes('Locum') && option !== 'Locum';
  }

  formatAsYYYYMMDD(date: Date): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  dateFilter = (d: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return d ? d >= today : false;
  };


  onStartDateChange(date: Date) {
    this.startDate = date;
  }

  onEndDateChange(date: Date) {
    this.endDate = date;
  }

  saveDateRange() {
    if (this.startDate && this.endDate && this.startDate <= this.endDate) {
      const dates: string[] = [];
      const current = new Date(this.startDate);

      while (current <= this.endDate) {
        dates.push(this.formatAsYYYYMMDD(current));
        current.setDate(current.getDate() + 1);
      }

      this.jobPostForm.get('availability')?.setValue(dates);
      this.jobPostForm.get('availability')?.markAsTouched();
      this.jobPostForm.get('availability')?.setErrors(null);
      this.openCalendarPopup = false;
    } else {
      this.jobPostForm.get('availability')?.setErrors({ required: true });
      this.jobPostForm.get('availability')?.markAsTouched();
    }
  }


  clearDateRange() {
    this.startDate = null;
    this.endDate = null;
    this.jobPostForm.get('availability')?.setValue([]);
    this.jobPostForm.get('availability')?.setErrors({ required: true });
    this.jobPostForm.get('availability')?.markAsTouched();
  }


  // formatDate(date: Date): string {
  //   return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  // }

  formatDate(date: any): string {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return ''; // or some fallback
    }
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  getLocumSummary(): string {
    const dates: string[] = this.jobPostForm.get('availability')?.value || [];

    if (dates.length === 0) return '';

    const sortedDates = dates
      .filter(v => /^\d{4}-\d{2}-\d{2}$/.test(v))
      .map(d => new Date(d))
      .sort((a, b) => a.getTime() - b.getTime());

    const start = this.formatDate(sortedDates[0]);
    const end = this.formatDate(sortedDates[sortedDates.length - 1]);

    return `${start} - ${end}`;
  }

  getLocumDate() {
    const values: string[] = this.jobPostForm.get('availability')?.value || [];
    const dateList = values
      .filter(v => /^\d{4}-\d{2}-\d{2}$/.test(v))
      .map(d => new Date(d))
      .sort((a, b) => a.getTime() - b.getTime());

    if (dateList.length) {
      this.startDate = dateList[0];
      this.endDate = dateList[dateList.length - 1];
    }
  }

  removeEmpType(type: string) {
    const control = this.jobPostForm.get('typeofemp');
    if (control) {
      const current = control.value as string[];
      const updated = current.filter((t) => t !== type);
      control.setValue(updated);
      this.onTypeOfEmpChange(); // Call this if needed
    }
  }

  // onJobDescChange(event: Event) {
  //   const input = event.target as HTMLTextAreaElement;
  //   this.jobDescCharCount = input.value.length;
  // }

    today: Date = new Date();

    allowAlphabetOnly(event: KeyboardEvent) {
  const pattern = /^[A-Za-z ]+$/;
  const inputChar = event.key;

  if (!pattern.test(inputChar)) {
    event.preventDefault();
  }
}


onMinInput() {
  const min = Number(this.jobPostForm.get('erangemin')?.value);
  const max = Number(this.jobPostForm.get('erangemax')?.value);

  // Clear MAX if MIN > MAX
  if (max && min > max) {
    this.jobPostForm.get('erangemax')?.setValue('');
    this.jobPostForm.get('erangemax')?.markAsTouched();
  }
}

onMaxInput() {
  const min = Number(this.jobPostForm.get('erangemin')?.value);
  const max = Number(this.jobPostForm.get('erangemax')?.value);

  // Set validation error if MAX < MIN
  if (min && max < min) {
    this.jobPostForm.get('erangemax')?.setErrors({ maxLessThanMin: true });
  } else {
    this.jobPostForm.get('erangemax')?.setErrors(null);
  }
}


// 
  youtubeLoomVimeoUrlValidator(control: AbstractControl): ValidationErrors | null {
    const url = control.value;
    if (!url) {
      return null;
    }
    const youtubeRegex = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
    const loomRegex = /^(https?\:\/\/)?(www\.)?(loom\.com\/share\/.+)$/;
    const vimeoRegex = /^(https?\:\/\/)?(www\.)?(vimeo\.com\/.+)$/;
    const isValidUrl = youtubeRegex.test(url) || loomRegex.test(url) || vimeoRegex.test(url);
    return isValidUrl ? null : { invalidVideoUrl: true };
  }

}